import type { Editor } from '@tiptap/react';
import { richTextToolbarStyles } from '@/shared/ui/rich-text-editor/styles';
import { ColumnControls, RowControls, TableHeaderControls } from './table-controls';

type TableToolbarProps = { editor: Editor; isDisabled: boolean };

/**
 * Controls that only make sense with the cursor inside a table.
 *
 * They are rendered only then, because these are not "disabled until useful"
 * actions — there is no table to act on, and a row of eight dead controls under
 * the writing area is noise. Deleting the table is the one destructive action,
 * so it is the one `danger` control.
 */
export function TableToolbar({ editor, isDisabled }: TableToolbarProps) {
  if (!editor.isActive('table')) return null;

  return (
    <div role="group" aria-label="Table" className={richTextToolbarStyles.rowSecondary}>
      <RowControls editor={editor} isDisabled={isDisabled} />
      <ColumnControls editor={editor} isDisabled={isDisabled} />
      <TableHeaderControls editor={editor} isDisabled={isDisabled} />
    </div>
  );
}
